import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=77a96f24"
import script from "./GenericError.vue?vue&type=script&lang=js"
export * from "./GenericError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports